export const AdjustmentTypes = {
  bonus: "bonus",
  deduction: "deduction",
  credit: "credit",
  debit: "debit",
};
